import React from "react";
import { formatDuration } from "../utils/formatDuration";

function formatTime(isoString) {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function SessionBlock({ session }) {
  const durationMs = new Date(session.end) - new Date(session.start);
  const uniquePageCount = new Set(
    session.pageViews.map((pv) => pv.pageName || pv.url || "(unknown)")
  ).size;

  return (
    <div className="session-block">
      <div className="session-header">
        <span className="session-meta">
          {new Date(session.start).toLocaleDateString()}
        </span>
        <span className="session-sub">
          {formatTime(session.start)} – {formatTime(session.end)}
          &nbsp;·&nbsp;{formatDuration(durationMs)}
          &nbsp;·&nbsp;{uniquePageCount} page{uniquePageCount !== 1 ? "s" : ""}
        </span>
        {session.browser && (
          <span className="session-sub">
            {session.browser} · {session.os}
          </span>
        )}
      </div>
    </div>
  );
}

export default function SessionTimeline({ sessions }) {
  if (!sessions || sessions.length === 0) {
    return <p className="text-muted">No sessions found for this period.</p>;
  }

  return (
    <div>
      {sessions.map((session) => (
        <SessionBlock key={session.sessionId} session={session} />
      ))}
    </div>
  );
}
